import { createOpenAIModalCommand } from '../pm-plugins/decoration/actions';
export var openAIModal = function openAIModal(_ref) {
  var invokedFrom = _ref.invokedFrom,
    aiOptIn = _ref.aiOptIn,
    configItem = _ref.configItem,
    editorView = _ref.editorView;
  if (!editorView) {
    return;
  }
  var openAIModalCommand = createOpenAIModalCommand({
    state: editorView.state,
    configItem: configItem,
    lastTriggeredFrom: invokedFrom,
    aiGlobalOptIn: aiOptIn
  });
  openAIModalCommand(editorView.state, editorView.dispatch);
};